export default __webpack_public_path__ + "static/media/Montserrat-SemiBold.4bbde92d.woff2";